import { render } from "./SubmitBtn.vue?vue&type=template&id=c202a95c"
import script from "./SubmitBtn.vue?vue&type=script&lang=js"
export * from "./SubmitBtn.vue?vue&type=script&lang=js"

import exportComponent from "/home/runner/work/wiki.zems.pro/wiki.zems.pro/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__